import { render, staticRenderFns } from "./DashboardPassword.vue?vue&type=template&id=a9408f80&"
import script from "./DashboardPassword.vue?vue&type=script&lang=js&"
export * from "./DashboardPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports